import React from 'react'
import PropTypes from 'prop-types'
import { createMuiTheme, withStyles, useTheme } from '@material-ui/core/styles'
import {
  Container,
  Grid,
  makeStyles,
  Button,
  Typography,
  useMediaQuery
} from '@material-ui/core'
import { noBorderContainerStyle } from '../styles/styles'
import { AMNCheckbox } from '@amn/shared'
import trackEvent from '../telemetryService'
import { grey } from '@material-ui/core/colors'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  buttonGrid: {
    display: 'flex',
    marginTop: '20px',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-end'
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center'
    }
  },
  cancelButton: {
    color: '#003C69',
    backgroundColor: '#FFF',
    border: '1px solid #CCCCCC',
    textTransform: 'none',
    height: '39px',
    width: '85%',
    [theme.breakpoints.up('sm')]: {
      width: '200px'
    }
  },
  sendButton: {
    color: 'white',
    height: '39px',
    textTransform: 'none',
    width: '85%',
    [theme.breakpoints.up('sm')]: {
      width: '200px'
    },
    '&:disabled': {
      backgroundColor: '#75787B !important',
      color: '#ffffff !important'
    }
  },
  disable: {
    color: 'white',
    backgroundColor: '#d5d5d5',
    minWidth: '120px',
    [theme.breakpoints.up('sm')]: {
      minWidth: '140px'
    },
    [theme.breakpoints.up('sm')]: {
      minWidth: '200px'
    },
    '&:hover': {
      backgroundColor: '#006FB9'
    }
  }
}))

export const DigitalSignature = (props) => {
  const classes = noBorderContainerStyle()
  const containerClasses = useStyles()
  const [checked, setChecked] = React.useState(false)
  const [disabled, setDisabled] = React.useState(true)
  const theme = useTheme()
  const { isEvaluator } = props
  const matches = useMediaQuery(theme.breakpoints.down('xs'))

  const handleChange = (event) => {
    setChecked(event.target.checked)
    setDisabled(!event.target.checked)
  }

  const handleSubmit = () => {
    trackEvent('Professional Reference Request - Form Complete', { isEvaluator })
    if (typeof props.onSubmit === 'function')
      props.onSubmit(checked)
  }

  const handleCancel = () => {
    if (typeof props.onCancel === 'function')
      props.onCancel(checked)
  }

  return (
    <Container>
      <div className={classes.root}>
        <Grid container alignItems='center' direction='row'>
          <div className={containerClasses.container}>
            <AMNCheckbox style={{position: 'relative', top: '-8px', left: '10px'}} theme={theme} onChange={handleChange} />
            <Typography variant='body1'>
              {
                isEvaluator
                  ? 'I attest that I am the evaluator named on this form and that the' +
                  ' information provided is complete and accurate to the best of my' +
                  ' knowledge.'
                  : 'I attest that the information I have given is true and accurate to the best of my' +
                  ' knowledge and that I am the individual completing this form. Falsification of any' +
                  ' information provided will result in being ineligible to travel with AMN Healthcare.' +
                  ' I hereby authorize the Evaluator to release employment information relative to this' +
                  ' experience to AMN Healthcare. I understand this reference will be subject to' +
                  ' verification by AMN Healthcare.'
              }
            </Typography>
          </div>
        </Grid>
        <Grid spacing={1} className={containerClasses.buttonGrid} container direction='row' alignItems='center'>
          {
            matches ? (
              <React.Fragment>
                <Grid xs={12} item style={{textAlign: 'center'}}>
                  <Button onClick={handleSubmit} variant='contained' color='secondary' disabled={disabled} className={containerClasses.sendButton}>{isEvaluator ? 'Complete' : 'Send Request'}</Button> {/* TODO: Replace this with SharedComponent Button */}
                </Grid>
                <Grid xs={12} item style={{textAlign: 'center'}}>
                  <Button onClick={handleCancel} className={containerClasses.cancelButton}>Cancel</Button> {/* TODO: Replace this with SharedComponent Button */}
                </Grid>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Grid item>
                  <Button onClick={handleCancel} className={containerClasses.cancelButton}>Cancel</Button> {/* TODO: Replace this with SharedComponent Button */}
                </Grid>
                <Grid item>
                  <Button onClick={handleSubmit} variant='contained' color='secondary' disabled={disabled} className={containerClasses.sendButton}>{isEvaluator ? 'Complete' : 'Send Request'}</Button> {/* TODO: Replace this with SharedComponent Button */}
                </Grid>
              </React.Fragment>
            )
          }
        </Grid>
      </div>
    </Container>
  )
}

DigitalSignature.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}
